import { createI18n } from "vue-i18n";
import Cookies from "js-cookie";

import enLocale from "./en";
import japaneseLocale from "./japanese.js";
import zhLocale from "./zh-Hans.js";
import tcLocale from "./zh-Hant.js";
import krLocal from "./kr.js";

const messages = {
  en: enLocale,
  jp: japaneseLocale,
  // 'zh-Hans': zhLocale,
  "zh-Hant": tcLocale,
  kr: krLocal,
  "zh-tw": tcLocale,
  "zh-hk": tcLocale,
  ja: japaneseLocale,
  ko: krLocal
};

const getLanguage = () => {
  let language = Cookies.get("language") || (navigator.language).toLowerCase();
  switch (language) {
    case 'ko':
      language = 'kr';
      break;
    case 'ja':
      language = 'jp';
      break;
    default:
      break;
  }
  console.log(language, '--language')
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      switch (locale) {
        case "zh-Hant":
          document.title = "雀夢麻雀";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "開心鬥一番麻雀麻將麻将mahjong鬥地主斗地主雀魂三國殺soul百家樂pokergame開枱喇德州撲克明星三缺一神來也大亨日本城单机跑馬仔立直竞技majiang雀姬十三張歡樂扑克赌场皇冠赢三张鋤大D"
            );
          document
            .querySelector('meta[name="description"]')
            .setAttribute(
              "content",
              "《雀夢麻雀》是一款免費下載的3D動漫風超燃麻將遊戲，支援多人線上進行即時對戰，還有三人麻將、四人麻將、段位戰等多種麻將模式供你選擇。你將體驗從場景到角色的全3D沉浸式代入感，以及熱血的和牌特效，還原真實的麻將手感。無論你是麻將新手還是高手，都可以在這裡找到屬於自己的樂趣！快來開啟你的立直麻將之旅吧！"
            );
          break;
        case "jp":
          document.title = "雀夢麻雀 - じゃんゆめ";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "麻雀まーじゃんmahjong無料まあじゃんマージャンゲームポーカー雀魂じゃんたま天鳳初心者mjモバイル一番街majsoulアニメ将棋ウォーズsoulカジノスロットパチンコルーレット大富豪ジャンカラ花札"
            );
          document
            .querySelector('meta[name="description"]')
            .setAttribute(
              "content",
              "雀夢麻雀 -じゃんゆめ- は、3Dアニメ風の無料麻雀ゲームで、オンライン対戦が可能です。三人麻雀、四人麻雀、段位戦など多様なモードを楽しめます。初心者から上級者まで、楽しさを見つけてください！"
            );
          break;
        case "kr":
          document.title = "마드- 리치 마작";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "모두의마블맞고섯다고스톱리치리치트리플타일마스터커넥팅루미큐브포커게임brainout와이파이필요없는퍼즐피망일본어마작솔리테어랜덤다이스재미있는로블록스피망뉴맞고쿠키런마피아카트라이더오목카카오톡"
            );
          document
            .querySelector('meta[name="description"]')
            .setAttribute(
              "content",
              "마드 리치 마작은 3D 애니메이션 스타일의 무료 마작 게임으로, 실시간 온라인 대전을 지원합니다. 다양한 모드에서 초보자와 고수 모두 즐길 수 있습니다! 지금 리치 마작 여행을 시작하세요!"
            );
          break;
        default:
          document.title = "Mahjong Dream";
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute(
              "content",
              "mahjong,mahjongfree,soul,japanese,citi,match,tiles,crunchyroll,tetris,animegames,solitaire,cardgames"
            );
          document
            .querySelector('meta[name="description"]')
            .setAttribute(
              "content",
              "Mahjong Dream is a free, high-energy 3D mahjong game with real-time multiplayer matches. Enjoy various modes, from Three-Player to Rank Matches, and experience an immersive environment. Whether a beginner or expert, find your enjoyment here!"
            );
      }
      return locale;
    }
  }
  return "en";
};

const i18n = createI18n({
  legacy: false,
  locale: getLanguage(),
  fallbackLocale: getLanguage(),
  globalInjection: true,
  messages: messages,
  warnHtmlMessage: false,
});

export default i18n;
